<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="banner-title">
                    <div class="title"><h1>免費線上句子檢查工具</h1></div>
                    <p>Trinka的句子檢查工具由人工智慧（AI）驅動，能夠即時檢查句子中是否存在任何類型的複雜錯誤。<br/>Trinka不僅可以糾正文法錯誤，還可以檢查您寫作中的句子結構和標點符號等是否正確。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-english-grammar-checker></app-english-grammar-checker>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>


<div class="gcBrowserSection">
    <div class="container">
        <div class="row">
            <div class="gcBrowserContainer">
                <h2>Trinka的句子檢查工具插件讓您隨時隨地都能準確寫作。</h2>
                <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"><img src="../../../assets/images/NewChromeIcon.svg" alt="chrome">安裝Chrome插件</a>
                <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank"><img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox"> 安裝Firefox外掛</a>
                <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge"> 安裝Edge外掛</a>
            </div>
        </div>
    </div>
</div>

<div class="signupmobile" style="display: none !important;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinkaPluginGCSection">
                    <h2>您的免費Trinka帳號</h2>
                    <p>每個月為您免費檢查多達5000個單詞的寫作，讓您的語言和寫作風格得到全面提升。</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">立即註冊！</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka_demo_wrap" style="display: none !important;">
    <div class="see_trinka_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="top_heading howItWorkHeading lineWhiteColor">
                        <h3>免費線上句子檢查工具</h3>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka的句子檢查工具由人工智慧（AI）驅動，能夠即時檢查句子中是否存在任何類型的複雜錯誤。<br/>Trinka不僅可以糾正文法錯誤，還可以檢查您寫作中的句子結構和標點符號等是否正確。</p>
                    </div>
                </div>
            </div>
            <div class="row match-box">
                <div class="col-lg-8 dflex">
                    <div class="editor_sections c-card" style="height:100%;">
                        <div class="gcLoaderSection" *ngIf="showloader">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="75" cy="50" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
                                </circle><circle cx="71.65063509461098" cy="62.5" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
                                </circle><circle cx="62.5" cy="71.65063509461096" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
                                </circle><circle cx="50" cy="75" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
                                </circle><circle cx="37.50000000000001" cy="71.65063509461098" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
                                </circle><circle cx="28.34936490538903" cy="62.5" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
                                </circle><circle cx="25" cy="50" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
                                </circle><circle cx="28.34936490538903" cy="37.50000000000001" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
                                </circle><circle cx="37.499999999999986" cy="28.349364905389038" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
                                </circle><circle cx="49.99999999999999" cy="25" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
                                </circle><circle cx="62.5" cy="28.349364905389034" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
                                </circle><circle cx="71.65063509461096" cy="37.499999999999986" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
                                </circle>
                            </svg>
                        </div>
                        <div style="display: none;" class="loading loader" #loading>&#8230;</div>
                        <div class="editor_top_section" [ngClass] = "(wordCount > maxLength) ? 'redWord' : '' ">
                            <!-- <span (click)="addDummyText()" class="dummy-text">Example text</span> -->
                            <span class="dorpdownText">
                                <button mat-button [matMenuTriggerFor]="sample" class="tryDemo_exampleText file_manager_dropdown">
                                    <!-- <img class="img-fluid" src="../../../../assets/images/UseExampleText.svg" alt="logo favicon"> -->
                                    <span>示例文本<i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </button>
                                <mat-menu #sample="matMenu" class="file_manager_sub_menus new_file_sections">
                                    <mat-radio-group aria-label="Select an option" (change)="addSampleData($event)" name="example">
                                        <ng-container *ngFor="let data of sampleData;index as i;">
                                            <mat-radio-button value="{{data.key}}">{{data.key}} </mat-radio-button><br>
                                        </ng-container>
                                    </mat-radio-group>
                                </mat-menu>
                            </span>
                            <span class="float-right word_count_section">字數: <b>{{wordCount}}/{{maxLength}}</b></span>
                        </div>

                        <!-- <div class="ck-editor" z>
                            <ck-editor name="editor1" [(ngModel)]="editorValue" [config]="config" language="en"
                                [fullPage]="false" (change)="onChange($event)" (blur)="onBlur($event)"
                                (focus)="onFocus($event)" (focusout)="outFocus($event)" (mouseup)="onMouseUp($event)"
                                (paste)="onPaste($event)" (keyup)="onKeyUp($event)" placeholder="Write your message">
                            </ck-editor>
                        </div> -->
                        <div class="ck-editor" style="height:280px; overflow: auto;">
                            <textarea #sampleEditor id ="sampleEditor" style="height: 100%;width: 100%;border: none;padding: 10px;outline: 0;display: block ;" (keyup)="onChange($event)" (paste)="onChange($event)" (change)="onChange($event)"></textarea>
                        </div>
                        <div class="Footer_button_section">
                            <div class="footer_radionButtons">
                                <div class="custom-control custom-radio d-inline">
                                    <input type="radio" class="custom-control-input" id="customControlValidation2"
                                        [checked]="languageSelection == 'us'" name="radio-stacked" value="us"
                                        name="style" (change)="languageTypeSelect('us')" required>
                                    <label class="custom-control-label mr-3"
                                        for="customControlValidation2">English-US</label>
                                </div>
                                <div class="custom-control custom-radio d-inline">
                                    <input type="radio" class="custom-control-input" id="customControlValidation3"
                                        [checked]="languageSelection == 'uk'" name="radio-stacked" value="uk"
                                        name="style" (change)="languageTypeSelect('uk')" required>
                                    <label class="custom-control-label"
                                        for="customControlValidation3">English-UK</label>
                                </div>
                            </div>
                            <div class="check_emailBox">
                                <!-- <input type="text" class="form-control" id="text-email" placeholder="Enter your email"
                                    [(ngModel)]="emailAdress"> -->
                                <button id="checkMyWritingButton" (click)="onGrammarCheck($event)" [disabled]="enableCheck || isProcessStarted"
                                    class="btn btn-primary">檢查我的寫作 
                                    <div class="gcLoaderSection" *ngIf="isProcessStarted">
                                        <svg style="margin: auto; display: block;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: inline-block;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                            <circle cx="75" cy="50" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
                                            </circle><circle cx="71.65063509461098" cy="62.5" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
                                            </circle><circle cx="62.5" cy="71.65063509461096" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
                                            </circle><circle cx="50" cy="75" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
                                            </circle><circle cx="37.50000000000001" cy="71.65063509461098" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
                                            </circle><circle cx="28.34936490538903" cy="62.5" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
                                            </circle><circle cx="25" cy="50" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
                                            </circle><circle cx="28.34936490538903" cy="37.50000000000001" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
                                            </circle><circle cx="37.499999999999986" cy="28.349364905389038" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
                                            </circle><circle cx="49.99999999999999" cy="25" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
                                            </circle><circle cx="62.5" cy="28.349364905389034" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
                                            </circle><circle cx="71.65063509461096" cy="37.499999999999986" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
                                            </circle>
                                        </svg>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="myWriting_text">By clicking Check My Writing, you are agreeing to our <a
                            routerLink="/termsofservices/">Terms of Service</a> and <a
                            routerLink="/privacypolicy/">Privacy Policy</a>.</p> -->
                              
                </div>
                <div class="col-lg-4 dflex">
                    <div class="gcResultSection c-card">
                        <div class="trinkaPluginGCSection">
                            <h2>您的免費Trinka帳號</h2>
                            <p>每個月為您免費檢查多達5000個單詞的寫作，讓您的語言和寫作風格得到全面提升。</p>
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">立即註冊！</a>
                            <h3>特殊功能：</h3>
                            <ul>
                                <li>文法和拼寫錯誤</li>
                                <li>單詞選擇</li>
                                <li>語言增強</li>
                                <li>寫作建議</li>
                            </ul>
                        </div>
                        <!-- <div class="editor_options_with_cards" *ngIf="alertErrorMessage == 'TRUE' &&!gec_result.length">
                            <h2>The issues detected in your text will be displayed here.</h2>
                            <h3>Our robust correction algorithm checks your English text for</h3>
                            <ul>
                                <li>Grammar errors</li>
                                <li>Spelling mistakes</li>
                                <li>US–UK spellings</li>
                                <li>Word usage</li>
                                <li>Language enhancement</li>
                                <li>Writing advice</li>
                            </ul>
                        </div> -->
    
                        <h4 *ngIf="!noeErrorFound && alertErrorMessage != 'TRUE'"
                            class="align-content-center again_check_my_writing tempClass" [innerHTML]="alertErrorMessage">
                        </h4>
                        <h4 *ngIf="!gec_result.length && noeErrorFound && alertErrorMessage != 'TRUE'"
                            class="align-content-center again_check_my_writing tempClass" [innerHTML]="alertErrorMessage">
                        </h4>
    
                        <div *ngIf="gec_result.length" class="mt-0 font-14 issueCountLabel-wrap">
                            <span class="issueCountLabel"> Issues Found: <span class="errors-ctn">{{gec_result.length}}</span></span>
                        </div>
    
                        <div class="errorPanel" *ngIf="gec_result.length">
                            <mat-accordion>
                                <ng-container *ngFor="let item of gec_result ; let j = index">
                                    <mat-expansion-panel class="mat-expansion-panel-spacing mb-2 mt-0 error-type"
                                        *ngIf="!item.isCorrected" (opened)="setStep(item, j)" (closed)="setStepOff(item, j)"
                                        [ngClass]="injectErrorClass(item)" [expanded]="j === 0">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <ng-container *ngIf="!item.isExpanded">
    
                                                    <div>
                                                        <strong> {{item.covered_text}}</strong>
                                                    </div>
                                                    <span *ngIf="item.error_type[0] == 1">&nbsp;(Grammar)</span>
                                                    <span *ngIf="item.error_type[0] == 2">&nbsp;(Spelling)</span>
                                                    <span *ngIf="item.error_type[0] == 3">&nbsp;(Writing
                                                        Adviser)</span>
                                                    <span *ngIf="item.error_type[0] == 4">&nbsp;(Enhancement)</span>
                                                </ng-container>
    
                                                <div *ngIf="item.isExpanded">
                                                    <strong *ngIf="item.error_type[0] == 1">&nbsp;
                                                        Grammar</strong>
                                                    <strong *ngIf="item.error_type[0] == 2">&nbsp;
                                                        Spelling</strong>
                                                    <strong *ngIf="item.error_type[0] == 3">&nbsp; Writing
                                                        Adviser</strong>
                                                    <strong *ngIf="item.error_type[0] == 4">&nbsp;
                                                        Enhancement</strong>
                                                </div>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                <span (click)="rejectChange(item,j,false)">
                                                    <img src="assets/images/delete-icon.png" alt="">
                                                </span>
    
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div *ngFor="let output of item.output; let k = index" class="error-main">
                                            <div class="error-inner">
                                                <div
                                                    *ngIf="(item.output[k] == '' && item.error_type[k] == 3 || item.error_type[k] == 4) && !item.cta_present[k]">
                                                    <label> {{item.covered_text}}</label>
                                                </div>
                                                <div *ngIf="item.output[k] != '' && item.cta_present[k]">
                                                    <b><s>{{item.covered_text}}</s></b> <span class="arrow"><img
                                                            src="assets/images/arrow.png" alt=""></span>
                                                    <label class="error-link" (click)="error_panel_action(item,j,output)"
                                                        [ngClass]="injectErrorClass(item)">{{item.output[k]}}</label>
                                                </div>
    
                                                <div *ngIf="item.output[k] == '' && item.cta_present[k]">
                                                    <label class="error-link" (click)="error_panel_action(item,j,output)"
                                                        [ngClass]="injectErrorClass(item)">Delete
                                                        '<span>{{item.covered_text}}</span>'</label>
                                                </div>
                                            </div>
                                            <div class="error-comment">{{item.comment[k]}}</div>
                                            <hr>
                                        </div>
                                    </mat-expansion-panel>
                                </ng-container>
                            </mat-accordion>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>最佳免費線上句子檢查工具</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Trinka的免費線上句子檢查工具可以正確構建您的句子，並使您的寫作易於理解。</p>
                    <p>Trinka能夠即時修訂句子結構和措辭中存在的問題。Trinka能夠識別任何被錯誤放置的單詞以及拼寫錯誤，並提供正確的替代方案。</p>
                    <div class="most_suited_point">
                        <ul>
                            <li>高級句子檢查和更正</li>
                            <li>高級文法檢查</li>
                            <li>免費使用</li>
                            <li>根據上下文更正拼寫</li>
                        </ul>
                    </div>
                    <p>Trinka的線上句子檢查工具可以檢測句子錯誤並提供帶有解釋的建議，讓您更好地理解。</p>
                    <p>註冊以免費解鎖更多功能！</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" class="cta-btn">開始使用</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckSection">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-4">
                <div class="grammarCheckHeadingSection">
                    <h2>誰可以使用Trinka的句子檢查工具？</h2>
                </div>
            </div>
            <div class="col-md-8">
                <div class="grammarCheckTextContent">
                    <p>不管您是學生、研究人員、作者、自由撰稿人還是博主，任何人都可以使用Trinka的高級句子檢查工具。我們的句子檢查工具能夠檢查所有類型的內容。</p>
                </div>
            </div>
        </div> 
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>Trinka句子檢查工具的主要功能</h2>
                    <div class="HeadingSubLine"></div>
                    <!-- <p>Enhance and check your writing instantly with the best English grammar checker. Trinka's advanced
                        checking feature highlights mistakes and provides contextual suggestions that make your writing
                        rise and shine.</p> -->
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>句子結構</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka能夠檢查您的句子結構、詞序是否正確以及是否有缺失的單詞，讓您的寫作清晰易讀。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>Coelomic fluid samples were <span class="wrong_text">analyzed</span>&nbsp;<span class="right_text"> analyzed using</span> various tools.</p>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>高級文法檢查</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka超越了基本的文法和拼寫檢查，它能夠評估您的寫作是否存在高級文法錯誤並且提供語言增強建議，以提高您的寫作品質。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Syntax</h4> -->
                            <p>Neither the healthy individuals nor the patient <span
                                class="wrong_text">recognize</span> <span
                                class="right_text"> recognizes</span> the visual discrepancies.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>用法和樣式</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka能夠檢測不正確或帶有偏見的辭彙，並且建議準確的單詞和正式的語氣。幫助您用精確和包容的語言給讀者留下深刻印象。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Advance Spelling</h4> -->
                            <p>However, this method is novel and is
                                <span class="wrong_text">very much</span>&nbsp;
                                <span class="right_text">considerably</span> different from the classical method.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>標點符號和拼寫檢查</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>除了句子和文法檢查外，Trinka還提供增強的標點符號檢查以提高作品的可讀性。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p><span class="wrong_text">Importantly</span>&nbsp;<span
                                class="right_text">Importantly,</span> there were no <span class="wrong_text">observble</span>&nbsp;
                                <span class="right_text">observable</span>
                                adverse effects</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="use_trinka_other_app">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="use_trinka_content">
                    <div class="use_trinka_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>在其他應用程式
                                <br />中使用Trinka</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/wordAdd_in.svg" alt="word addin">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="chrome">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">Coming Soon</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/safari_logo.png" alt="safari logo">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="moreEffectiveSection">
    <div class="container">
        <div class="row flex-row-reverse align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>Trinka的免費句子檢查工具是如何工作的？</h2>
                    <p>Trinka的句子檢查工具從不同領域研究文章中的數百萬個優秀句子中學習。它能夠檢查您的句子結構、措辭、詞序和用法，確保您的句子正確、連貫且完整。Trinka的句子檢查工具易於使用，只需添加您的內容，它就可以建議所有文法增強和更正，無論錯誤有多小。</p>
                    <p>Trinka可以幫您糾正句子中所有類型的文法和拼寫錯誤，從而自信地與讀者交流。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/WritingMoreEffective.png" alt="writing">
                </div>
            </div>
            
        </div>
        <div class="row colunmChangesSection align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>為什麼要使用句子檢查工具？</h2>
                    <p>Trinka的句子檢查工具由人工智慧（AI）驅動，可以識別句子中的不一致之處，以及文法、標點符號和拼寫錯誤。Trinka使用最新的機器學習和自然語言處理技術開發而成，可提供最準確的建議。</p>
                    <p>使用我們的句子檢查工具來校對您的內容，不僅使您要表達的資訊和科學內容更加清晰，還可以為您節省大量時間從而專注於更深層次的寫作問題。我們的句子檢查工具適用於所有類型的寫作，包括技術寫作，處理複雜和困難的單詞也遊刃有餘。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/LearnGrammarwithTrinka.png" alt="learn grammar with trinka">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>Testimonials</h2>
                    <p>Check what users are saying about Trinka</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="">
                    </div>
                    <p>The grammar checking tool exceeds Grammarly! I re-checked some documents that I had checked
                        earlier with Grammarly. I was pleasantly surprised to see such a product from India!</p>
                    <div class="testimonals_footer">
                        <p>Radiologist, India</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="">
                    </div>
                    <p>First, I love Trinka. Congratulations on developing something that extensively aids editing,
                        especially critical grammar conventions and word count reductions.</p>
                    <div class="testimonals_footer">
                        <p>Academic Editor, USA</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="">
                    </div>
                    <p>I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar
                        checker I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is
                        widely used in academia.</p>
                    <div class="testimonals_footer">
                        <p>PhD Scholar, UK</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<section class="section-md gc-testimonials-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center testi">
                <div class="GCTestmonials">
                    <h2>使用感言</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="testimonial-wrap">
                        <!-- <div class="testimonal-icon">
                            <img src="../../../assets/images/testimonial.png" alt="grammar-checker-testimonial">
                        </div> -->
                        <div class="testimonial-slider">
                            <div id="testi" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#testi" data-slide-to="0" class="active"></li>
                                    <li data-target="#testi" data-slide-to="1"></li>
                                    <li data-target="#testi" data-slide-to="2"></li>
                                    <li data-target="#testi" data-slide-to="3"></li>
                                    <li data-target="#testi" data-slide-to="4"></li>
                                    <li data-target="#testi" data-slide-to="5"></li>
                                    <li data-target="#testi" data-slide-to="6"></li>
                                    <li data-target="#testi" data-slide-to="7"></li>
                                    <li data-target="#testi" data-slide-to="8"></li>
                                    <li data-target="#testi" data-slide-to="9"></li>
                                    <li data-target="#testi" data-slide-to="10"></li>
                                    <li data-target="#testi" data-slide-to="11"></li>
                                    <li data-target="#testi" data-slide-to="12"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/James-Smith.jfif" alt="James-Smith">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我一下就愛上Trinka了。祝賀你們開發出這個可以大幅協助編輯的程式，尤其是符合重要的文法慣例和具備精簡字數功能的工具。
                                                    </p>
                                                    <p class="authorNameText">James Smith</p>
                                                    <span class="authorDesignationText">學術編輯, 美國</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="Rosa-Diaz-Sandoval">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">對於說其他語言的人來說，用正確的英語文法和風格編寫文章不是一件容易的事。如果沒有協助工具，尤其是學術寫作，很難在文件中發現小錯誤。我嘗試將TrinkaAI作為自動校正工具，並對建議的更正和回饋感到非常滿意。透過回饋，能瞭解為什麼必須考慮建議的更改。</p>
                                                    <p class="authorNameText">Rosa Diaz Sandoval</p>
                                                    <span class="authorDesignationText">物理和數學博士, 墨西哥</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="Dr_Farooq_Rathore">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我使用Trinka兩個多月了。我主要用它來改進我為國內和國際生物醫學期刊撰寫的科學手稿的語言、文法和句法。介面很使用者友好，並且軟件高效且好用。根據需要編輯手稿的不同選項有助於決定我需要關注的地方。自動編輯的幫助很大，帶有修訂歷史的補充頁面很有用。Trinka一直在更新，我寫這篇文章時就注意到添加了一個新功能“一致性”。最好的是所有這些都是完全免費的。我強烈鼓勵作者和研究人員，特別是那些英語不好的人嘗試一下，親眼目睹驚人的結果。</p>
                                                    <p class="authorNameText">Farooq Rathore博士</p>
                                                    <span class="authorDesignationText">
                                                        助理教授兼系主任, 巴基斯坦</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Georgieva-Milena.jfif" alt="Georgieva-Milena">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka.ai是我最喜歡的文法和拼寫編輯。該應用程式使用效果好，快速而明確！完全滿意！</p>
                                                    <p class="authorNameText">Milena Georgieva</p>
                                                    <span class="authorDesignationText">研究員</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="Dinesh Gupta">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">這是一個超越Grammarly的文法檢查工具！我用Trinka重新檢查了用Grammarly檢查過一些文檔。看到來自印度的如此優越產品，我感到非常驚喜！</p>
                                                    <p class="authorNameText">Dinesh Gupta</p>
                                                    <span class="authorDesignationText">放射科醫師, 印度</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Edith-Davies.jpg" alt="Edith-Davies">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我已經測試過Trinka，並對其出色的功能印象深刻。它比我使用的文法檢查器做得更好。做得好！我已經告訴我研究實驗室的同事使用Trinka。希望在學術界得到廣泛應用。</p>
                                                    <p class="authorNameText">Edith Davies</p>
                                                    <span class="authorDesignationText">博士生, 英國</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Noor-Al-rishi.png" alt="Noor-Al-rishi">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka AI建議的更正和回饋令我驚喜。使用簡單，非常有益。</p>
                                                    <p class="authorNameText">Noor Al-rishi</p>
                                                    <span class="authorDesignationText">化學學者, 沙烏地阿拉伯</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Nwaji-Jude.jpg" alt="Nwaji-Jude">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">使用Trinka是美妙的體驗，如果不使用它評估稿件，我幾乎無法提交任何手稿。總之，Trinka成了我的是救命稻草。</p>
                                                    <p class="authorNameText">Nwaji Jude</p>
                                                    <span class="authorDesignationText">研究員</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="Stumpf-Curtis">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我喜歡使用Trinka作為我編輯文稿的最終檢查。它確實有助於找到在編輯過程中漏掉的剩餘錯誤。我真的很喜歡這個平台。大拇指向下這個按鈕非常有用。
                                                    </p>
                                                    <p class="authorNameText">Stumpf Curtis</p>
                                                    <span class="authorDesignationText">研究員</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dyke-Gareth.jfif" alt="Dyke-Gareth">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我認為Trinka.ai 是一個非常有趣且很有發展潛力的主意，尤其是對於編輯/出版社/期刊。我使用這個平台檢查我的編輯工作，非常有用。</p>
                                                    <p class="authorNameText">Gareth Dyke</p>
                                                    <span class="authorDesignationText">研究員</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="Bhargava Sharma">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我對整體表現感到滿意。我使用Grammarly已經有很長一段時間了，但是在學術或技術寫作方面，Trinka絕對是更好的選擇。學術文件設置和自動文件編輯是我最喜歡的功能。</p>
                                                    <p class="authorNameText">Bhargava Sharma</p>
                                                    <span class="authorDesignationText">流行病學家, 印度</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Ralph-Bailey.jfif" alt="Ralph-Bailey">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka已成為我文法校正的首選工具。人工智慧驅動的更正和語言增強使寫作變得更加容易。現在，我可以更專注於研究，而不是糾正文稿中的錯誤。</p>
                                                    <p class="authorNameText">Ralph Bailey</p>
                                                    <span class="authorDesignationText">神經科醫生, 美國</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Thomas-Andres.jfif" alt="Thomas-Andres">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">基於AMA風格指南的文法糾正和建議真的令人印象深刻！Trinka確實是醫學寫作最好的文法校正工具。
                                                    </p>
                                                    <p class="authorNameText">Thomas Andres</p>
                                                    <span class="authorDesignationText">心臟學專家, 巴西</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#testi" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    

<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>句子檢查工具讓您的寫作更加完美！</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" id="grammerSignUpButton">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>免費註冊！</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckQuestions">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="GCQuestions">
                    <h2>Trinka的句子檢查工具常見問題解答</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
                <div class="row">
                    <div class="offset-md-1 col-md-10">
                        <div class="answersSections">
                            <div class="accordion" id="QeustionGrammarChecks">
                                <div class="card">
                                    <div class="card-header" id="QuestionGCOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCOneContent" aria-expanded="true"
                                            aria-controls="QuestionGCOneContent">
                                            在哪里可以檢查我的句子？</a>
                                    </div>
        
                                    <div id="QuestionGCOneContent" class="collapse show"
                                        aria-labelledby="QuestionGCOne" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>只需將您的內容粘貼到此頁面的編輯器中，然後單擊“檢查我的寫作”，Trinka將突出顯示所有句子結構和使用錯誤，並提供準確的上下文建議。</p>
                                        </div>
                                    </div>
                                </div>        
                                
                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTwoContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwoContent">如何檢查我句子中的文法是否正確？</a>
                                    </div>
        
                                    <div id="QuestionGCTwoContent" class="collapse"
                                        aria-labelledby="QuestionGCTwo" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>使用Trinka的句子檢查工具，您只需單擊幾下即可檢查您的寫作是否存在文法和標點符號錯誤，以及單詞是否使用正確。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCThreeContent" aria-expanded="true"
                                            aria-controls="QuestionGCThreeContent">Trinka的句子檢查工具可以免費使用嗎？</a>
                                    </div>
        
                                    <div id="QuestionGCThreeContent" class="collapse"
                                        aria-labelledby="QuestionGCThree" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>絕對免費！您只需使用此頁面上的編輯器即可檢查和更正您的句子。如果您想檢查更長的文檔，可以在<a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">此處註冊</a>並免費使用更多功能。</p>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="card">
                                    <div class="card-header" id="QuestionGCFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFourContent" aria-expanded="true"
                                            aria-controls="QuestionGCFourContent">我可以檢查不同網站上的句子嗎？</a>
                                    </div>
        
                                    <div id="QuestionGCFourContent" class="collapse"
                                        aria-labelledby="QuestionGCFour" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>可以！您只需在GoogleChrome、火狐Firefox或微軟Edge瀏覽器上安裝我們的<a [routerLink]="['/browser-plugin']">插件</a>，就可以在任何網站上使用Trinka的句子檢查工具。</p>
                                        </div>
                                    </div>
                                </div>

                                
        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




<!-- Modal -->
<div class="modal fade" id="usageLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="usageLimitExhaustedLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" id="closedExceededPopup" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="upgradePremiumSection">
            <div class="upgradeHeaderSection">
               <div class="upgradeHeaderSection_overlay"></div>
               <h4>哎呀！超出內容限制。</h4>
            </div>
            <div class="upgradeBodySection">
               <!-- <h2>Sign Up for free and get 5000 words/month</h2> -->
               <p style="margin: 0; margin-top: 10px;">免費的Trinka帳戶每個月最多可以檢查 5000 字的寫作。您只需要免費註冊即可使用。</p>
               <!-- <p> All you need to do is Sign Up for free.</p> -->
               <div class="goupgradeButton">
                <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">免費註冊</a>
                <button id="FooterClosedExceededPopup">返回編輯器</button>
             </div>
            </div>
         </div>
      </div>
    </div>
</div>

  <!--Modal for accept limit exceeded-->
  <div class="modal fade" id="acceptedLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="acceptedLimitExhaustedLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" id="closedAcceptedLimitExhaustedPopup"   (click)="hideModal3()"  class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
         <div class="limitExhaustedBody">
             <div class="limitExhaustedLeftContent">
                 <div class="logoSection">
                     <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                 </div>
                 <div class="ExhaustedLeftContent">
                     <h2>更多文法更正和一鍵編輯。</h2>
                     <a href="https://cloud.trinka.ai/signup?_rg=Sentence-Checker-JS-TW" target="_blank">獲取免費帳戶</a>
                 </div>
             </div>
             <div class="limitExhaustedRightContent">
                 <div class="rightInnerContent">
                     <img class="backgourndImageSection" src="../../../assets/images/home_banner.jpg" alt="background">
                     <div class="imagesOverlaySection"></div>
                 </div>
                 <div class="ExhastedRightContainer">
                    <img src="../../../assets/images/SentenceStructureImg.png" class="grammarCheckCardImg" alt="sentence structure" >
                    <img src="../../../assets/images/AdvancedGrammarSentenceCheck.png" alt="advance grammar" class="EnhanmentCheckCardImg" alt="" >
                    <a href="https://cloud.trinka.ai/signup?_rg=Sentence-Checker-JS-TW" target="_blank">獲取免費帳戶</a>
                </div>
             </div>
         </div>

      </div>
    </div>
</div>